import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { getTripsDurationByVehicleId } from '../../services/TripsService';
import { TripsDurationResponse } from '../../types/Trips';

function useGetTripsDurationByVehicleId(fleetId: string, vehicleId: string): UseQueryResult<TripsDurationResponse> {
  return useQuery(
    ['trips-aggregation-duration', fleetId, vehicleId],
    async (): Promise<TripsDurationResponse> => getTripsDurationByVehicleId(fleetId, vehicleId),
    {
      retry: 1,
      retryDelay: 3000,
      keepPreviousData: true,
    },
  );
}

export default useGetTripsDurationByVehicleId;
